// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { loading, isLoggedIn } = useAuth();

  // Auth state is resolved from the httpOnly cookie via /me on load. Until that
  // resolves we can't know if the user is logged in, so hold rendering rather
  // than flashing a redirect.
  if (loading) {
    return <div className="min-h-screen" aria-busy="true" />;
  }
  if (!isLoggedIn) {
    return <Navigate to="/loginpage" replace />;
  }
  return children;
};

export default ProtectedRoute;
